import { Box } from '@mui/material';
import { PropsWithChildren } from 'react';
import theme from '../../theme';

export function ContentBox({ children }: PropsWithChildren) {
  return <Box
    bgcolor={theme.palette.background.default}
    flexGrow={1}
    height={1}
    p={5}
    display="flex"
    flexDirection="column"
    gap={5}
    sx={{ overflowY: "auto" }}
  >
    {children}
  </Box>;
}